import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useBreakpoint from '../../../../shared/hooks/useBreakpoint';

const NotSelected = ({ offer: { user_offer:userOffer } }) => {
  const breakpoint = useBreakpoint();
  const { t } = useTranslation();

  if (!userOffer) return <div></div>;

  return (
    <React.Fragment>
      {breakpoint !== 'xs' ?
        <h3 className="mb-4-5">{t('influencers.pages.campaign.status.not_selected')}</h3> :
        <h4 className="mb-4-5">{t('influencers.pages.campaign.status.not_selected')}</h4>
      }
      <div>
        {t('influencers.pages.campaign.status.desc_not_selected')}
      </div>
    </React.Fragment>
  );
};

NotSelected.propTypes = {
  offer: PropTypes.object.isRequired
};

export default NotSelected;
